import styled, { css } from 'styled-components';
import { Link } from 'react-router';

import { color } from 'app/shared/styles_js/variables';

const border = css`
  border-style: solid;
  border-width: 0 0 1px 0;
  border-color: ${color.grayLight};
`;

export const NavigationItemSt = styled.div`
  width: 100%;
  padding-right: 24px;
  padding-left: 24px;
  ${props => props.border && border};

  ${props =>
    props.isSubItem &&
    css`
      & > a {
        min-height: 48px;
        font-size: 14px;
      }
    `};

  ${props =>
    props.isActive &&
    css`
      & > a {
        font-weight: 400;
      }
    `};
`;

export const LinkSt = styled(Link)`
  display: flex;
  min-height: 64px;
  flex-direction: row;
  align-items: center;
  font-size: 16px;
  letter-spacing: 0.2px;
  color: ${color.brandSecondary};
`;

export const IconSt = styled.i`
  height: 16px;
  width: 16px;
  margin-right: 24px;
`;
